import { Fragment, h } from "preact";

import {

    Box,
    Chip,

    Typography,

} from "@mui/material";

import { useState, useEffect, useContext, } from "preact/hooks";

import { AppContext } from "../../AppContext";
import AddReactionIcon from "@mui/icons-material/AddReaction";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import CardTemplate from "../Common/CardTemplate";

export default function MentoringCard({ state, id }) {
    const app = useContext(AppContext);
    return (

        <CardTemplate
            title="Vos parrainages"
            buttons={<ButtonWithTooltipAndBadge
                tooltip="Invitez un contact"
                icon={<AddReactionIcon />}
                onclick_cb={() => {
                    app.refPopUp.current.handleChangeState(
                        { opened: true, type: "003", params: { uid: id, } }
                    )
                }}
                badge={false} />
            }

            content={<Fragment>
                {state.ctx.mentored.length > 0 &&
                    state.ctx.mentored.map((m) =>
                    (<Box display="flex" alignItems={"center"} justifyContent={"space-between"}>
                        <Box p={1}>
                            <Typography variant="body1">{m.n} <b>{m.t === 1 ? "Ambassadeur" : m.t === 2 ? "Vendeur" : "Acquéreur"}</b></Typography>
                            <Typography variant="caption">{m.e} </Typography>
                        </Box>
                        <Box p={1}>
                            <Chip
                                size="small"
                                color={m.iso ? "success" : "warning"}
                                label={m.iso ? "Inscrit" : "Pas encore inscrit"}
                            />
                        </Box>
                    </Box>))}

                {!state.ctx.mentored || (state.ctx.mentored && state.ctx.mentored.length === 0) && <Typography variant="body1">Vous n'avez encore parrainé personne</Typography>}
            </Fragment>}
        />

    );
}
